import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { spaceUpperCasePipe } from './spaceUpperCase';

@NgModule({
    imports: [ 
        CommonModule 
    ],
    declarations: [ 
        spaceUpperCasePipe
    ],
    exports: [ 
        spaceUpperCasePipe
    ]
})
export class PipesModule { }
